import React from "react";
import Slider from "react-slick";
import useWindowSize from "../../../hooks/useWindowSize";

const CertificatePerk = ({ selectedDomain, name }) => {
  const { width } = useWindowSize();

  const settings = {
    dots: false,
    slidesToShow: 2.4,
    rows: 1,
    speed: 300,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow:
            width <= 360 ? 1.1 : width <= 375 ? 1.2 : width <= 393 ? 1.25 : 1.3,
          infinite: false,
          dots: false,
          arrows: false,
          swipeToSlide: true,
        },
      },
    ],
  };

  // useEffect(()=>{

  // },[lastEnrolled])

  return (
    <div className="mt-3 w-full">
      <Slider {...settings}>
        {selectedDomain?.length > 0 &&
          selectedDomain?.map((item, index) => (
            <div className="w-full" key={index}>
              <div
                className="relative flex h-full w-[99%] flex-col items-center justify-center px-1 font-light text-white"
                key={index}
              >
                <div className="h-full w-[260px] rounded-xl">
                  <img
                    src="https://img.learntube.ai/public-assets/PRICING/Group_7719.svg?updatedAt=1684572338778"
                    alt=""
                    className="h-auto w-full rounded-xl"
                  />
                </div>
                <div className="absolute top-2 right-1 flex w-full flex-col items-center justify-center md:top-4">
                  <img
                    src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/learntube.png?updatedAt=1688019617510"
                    className=" w-12 self-center"
                    alt=""
                  ></img>
                  <div className="absolute top-6 self-center text-sm">
                    Certificate of Completion
                  </div>
                  <div className="certificate absolute  top-[42px] text-[8px] italic">
                    This is presented to
                  </div>
                  <div className="text-md absolute top-[50px]">{name}</div>
                  <div className="certificate absolute  top-[72px] text-[8px] italic">
                    for successfully completing
                  </div>
                  <div className="certificate absolute  top-[86px] text-[10px] italic">
                    {item}
                  </div>
                  <img
                    src="https://img.learntube.ai/public-assets/AI_Syllabus_generator/CEOSign.png?updatedAt=1688019617564"
                    className=" absolute top-[104px] w-14 self-center"
                    alt=""
                  />
                  <div className=" absolute top-[122px] text-[8px]">
                    Shronit Ladhani
                  </div>
                  <div className="absolute top-[134px] text-[8px] font-medium">
                    Founder and CEO ,CAREERNINJA
                  </div>
                  <div className=" absolute top-[146px] text-[6px] ">
                    Id: Dat183643992473
                  </div>
                  <div className=" absolute top-[156px] text-[6px] ">
                    Date: {new Date().toLocaleDateString("en-US")}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </Slider>
    </div>
  );
};

export default CertificatePerk;
